import StatsCards from "./Dashboard/StatsCards";
import UploadCard from "./Dashboard/UploadCard";
import SummaryCard from "./Dashboard/SummaryCard";
import BuyCreditsCard from "./Dashboard/BuyCreditsCard";
import SavingsChart from "./Dashboard/SavingsChart";
import { useEffect, useState } from "react";
import reapi from "../apis/reapi";
import { message, Spin } from "antd";
import StatCard from "../Components/StatCard";
import { BarChart3, IndianRupee, TrendingUp, Wallet } from "lucide-react";
import RecentOptimizations from "./Dashboard/RecentOptimizations";
import Loading from "react-loading";
import { AnimatePresence,motion } from "framer-motion";

export default function Dashboard() {

  const [dashboard, setDashboard] = useState(null);
  const [loading, setLoading] = useState(false);

  const token = localStorage.getItem('token')


  const fetchDashboard = async () => {
    try {
      setLoading(true);

      const res = await reapi.get(`/dashboard`, {
        headers: {
          "Authorization": `Beaer ${token}`
        }
      });

      setDashboard(res.data.data);
      localStorage.setItem('userInfo', JSON.stringify(res.data.data?.user));
      window.dispatchEvent(new Event("userUpdated"));
    } catch (error) {
      message.error("Dashboard load failed");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDashboard();
  }, []);

  const user = dashboard?.user;
  const stats = dashboard?.stats;
  const recent = dashboard?.recent || [];

  function capitalizeFirstLetter(str) {
  if (!str) return ""; // Handle empty strings safely
  return str.charAt(0).toUpperCase() + str.slice(1);
}


  return (
  <AnimatePresence mode="wait">
    <Spin spinning={loading} tip="Loading dashboard..." >
    <div className="space-y-6">

      <div>
        <h1 className="text-3xl font-bold">
          Welcome back, {capitalizeFirstLetter(user?.name)} 👋
        </h1>

        <p className="text-gray-500">
          Optimize your Meesho product images and reduce shipping charges.
        </p>
      </div>

      <motion.div
                    key="form"
                    initial={{ opacity: 0, y: 15 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -15 }}
                    transition={{ duration: 0.35 }}
                  >

      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-5">
        <StatCard
          icon={<Wallet size={24} />}
          title="Available Credits"
          value={user?.wallet || 0}
          iconBg="bg-purple-100"
          iconColor="text-purple-600"
        />

        <StatCard
          icon={<TrendingUp size={24} />}
          title="Total Savings"
          value={`₹${stats?.totalSavings || 0}`}
          iconBg="bg-green-100"
          iconColor="text-green-600"
          valueColor="text-green-600"
        />

        <StatCard
          icon={<BarChart3 size={24} />}
          title="Total Optimizations"
          value={stats?.totalOptimizations || 0}
          iconBg="bg-blue-100"
          iconColor="text-blue-600"
        />

        <StatCard
          icon={<IndianRupee size={24} />}
          title="Highest Savings"
          value={`₹${stats?.highestSaving || 0}`}
          iconBg="bg-orange-100"
          iconColor="text-orange-600"
        />
      </div>
                  </motion.div>


      {/* <StatsCards /> */}

      <div className="grid grid-cols-1 xl:grid-cols-3 gap-5">
        <div className="xl:col-span-2">
          <UploadCard />
        </div>

        <div className="space-y-5">
          <SummaryCard
            totalUploads={stats?.totaluploads}
            totalSavings={stats?.averageSavings}
            totalCreditsUsed={stats?.totalCreditsUsed}
            memberSince={
              dashboard?.user?.createdAt
                ? new Date(
                  dashboard.user.createdAt
                ).toLocaleDateString("en-IN", {
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
                })
                : "-"
            }
          />
          <BuyCreditsCard />
        </div>
      </div>

      <div className="grid grid-cols-1 xl:grid-cols-3 gap-5">
        <div className="xl:col-span-2">
          <RecentOptimizations data={dashboard?.recent || []} />
        </div>

       {/* <SavingsChart data={dashboard?.chartData || []} /> */}
      </div>

    </div>
    </Spin>
    </AnimatePresence>
  );
}